import React from "react";
import SmallCard from "../../../components/page/SmallCard";
import PropTypes from "prop-types";

function GerarCobrancasCards({ cards }) {
  return (
    <>
      <SmallCard
        title="Cobranças geradas"
        value={cards?.cobrancas_geradas}
        icon="mdi mdi-cash-check"
      />
      <SmallCard
        title="Cobranças liberadas"
        value={cards?.cobrancas_liberadas}
        icon="mdi mdi-credit-card-refresh"
      />
      <SmallCard
        title="Cobranças em edição"
        value={cards?.cobrancas_em_edicao}
        icon="mdi mdi-credit-card-search"
      />
    </>
  );
}

GerarCobrancasCards.propTypes = {
  cards: PropTypes.shape({
    cobrancas_geradas: PropTypes.number.isRequired,
    cobrancas_liberadas: PropTypes.number.isRequired,
    cobrancas_em_edicao: PropTypes.number.isRequired,
  }).isRequired,
};

export default GerarCobrancasCards;
